import { render, staticRenderFns } from "./DeviceEditCard.vue?vue&type=template&id=b2bf9faa&"
import script from "./DeviceEditCard.vue?vue&type=script&lang=js&"
export * from "./DeviceEditCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports